

import Vue from 'vue'
import App from './App'
import router from './router'
import store from './stores'
import {getApi, postApi} from './api'
import infiniteScroll from 'vue-infinite-scroll'
import vuescroll from 'vue-scroll'
import wx from 'weixin-js-sdk'
import jsCallBack from './js/jsCallBack'
import JsAction from '@/js/JsAction' 
import clipboard from 'clipboard'
import setBrowse from './js/setBrowse' 


import config from './config'

import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'


Vue.use(ConfirmPlugin)
Vue.use(ToastPlugin)
Vue.use(LoadingPlugin)
Vue.use(AlertPlugin)



Vue.prototype.$getApi = getApi
Vue.prototype.$postApi = postApi
Vue.prototype.$config = config
Vue.prototype.$wx = wx
Vue.prototype.Clipboard = clipboard

window.foo = jsCallBack
window.closeTimer = null
window.isClose = false
window.keyBack = () => {
let path = router.history.current.path
if (path === '/' || path === '/Login' || path === '/TaskIndex' || path === '/Mall' || path === '/Wallet' || path === '/my') {
if (window.isClose) {
let jsRequest = {'ActionName': 'exitApp', 'Callback': '', 'Params': '{}'}
JsAction.doAction(jsRequest)
}
Vue.$vux.toast.text('双击退出应用', 'bottom')
window.isClose = true
window.closeTimer = setTimeout(() => {
window.isClose = false
}, 360)
} else {
router.back()
}
}

Vue.use(infiniteScroll)
Vue.use(vuescroll, {throttle: 200})

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
el: '#app',
router,
store,
components: { App },
template: '<App/>'
})

let timer = null
router.beforeEach(function (to, from, next) {
store.commit('updateLoadingStatus', {isLoading: true})
clearTimeout(timer)
timer = setTimeout(() => {
store.commit('updateLoadingStatus', {isLoading: false})
}, 2000)
let _to = to.meta.isNeedLogin
setBrowse(getApi, to)
if (_to) {
if (!window.localStorage.userData) {
router.push({
name: 'Login',
query: {
type: 1
}
})
Vue.$vux.toast.text('请先登录', 'middel')
}
}
next()
})

router.afterEach(function (to) {
setTimeout(() => {
store.commit('updateLoadingStatus', {isLoading: false})
}, 500)
})



// WEBPACK FOOTER //
// ./src/main.js